import React from 'react';
import { Plane } from 'lucide-react';

function Heros() {
  return (
    <div className="bg-primary text-white py-5">
      <div className="container py-5">
        <div className="row align-items-center">
          <div className="col-md-6 mb-4 mb-md-0 text-center text-md-start">
            <h1 className="display-4">Welcome to DroneShala</h1>
            <p className="lead mb-4">
              Your comprehensive platform for drone education, innovation, and community building
            </p>
            <button className="btn btn-light btn-lg">Start Learning</button>
            <button className="btn btn-light btn-lg mx-2">Start Learning</button>
            <button className="btn btn-light btn-lg">Start Learning</button>
          </div>
          <div className="col-md-6 text-center">
            <Plane size={200} className="animate-pulse transform rotate-45" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Heros;
